import { render, staticRenderFns } from "./Investigator.vue?vue&type=template&id=ab6921b2&"
import script from "./Investigator.vue?vue&type=script&lang=js&"
export * from "./Investigator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports